import "./css/app.scss";

import "./ts/neto.js";
import "./ts/activeTabs.js";
import { addEvent } from "./ts/utils";
import headerSticky from "./ts/stickyHeader";
import lazyLoad from "./ts/lazyLoad";
import loadSprite from "./ts/loadSprite";
import dropdown from "./ts/dropdowns";
import popup from "./ts/popups";
import tabs from "./ts/tabs";
import mobMenu from "./ts/mobMenu";
import slider from "./ts/slide";
import accordian from "./ts/accordian";
import readMore from "./ts/readmore";
import stockLocation from "./ts/stockLocation";
import cartLine from "./ts/cartLine";
import showHideFilters from "./ts/showHideFilters";
import "./ts/newPopup";

addEvent();
loadSprite.init();
lazyLoad.init();
dropdown.init();
popup.init();
tabs.init();
mobMenu.init();
headerSticky.init();
slider.init();
accordian.init();
readMore.init();
stockLocation.init();
cartLine.init();
showHideFilters.init();